import { render, staticRenderFns } from "./UserShowScreen.vue?vue&type=template&id=4e51eb6b&"
import script from "./UserShowScreen.vue?vue&type=script&lang=js&"
export * from "./UserShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports